import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type DocumentUploadRequestDTO,
	postDocumentV2,
} from "web_myplann/Infrastructure/Api/Api";
import {
	processResponse,
	withTimeout,
} from "web_myplann/Infrastructure/Api/ApiUtils";

const UPLOAD_TIMEOUT_MS = 120_000;

type Variables = { data: DocumentUploadRequestDTO };

export const useDocumentUploadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(
			withTimeout(
				(args: Variables, options) => postDocumentV2(args.data, options),
				UPLOAD_TIMEOUT_MS,
			),
		),
		onSettled: (_data, _error, { data }: Variables) => {
			queryClient.invalidateQueries({ queryKey: DocumentKeys.allLists });
			if (data.portfolioId || data.propertyId) {
				queryClient.invalidateQueries({ queryKey: PortfolioKeys.all });
			}
		},
	});
};
